import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Ticket } from "@phosphor-icons/react";
import { toast } from "sonner";
import { SocialOtpAuth } from "@/components/SocialOtpAuth";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const res = await register(form);
    setLoading(false);
    if (res.ok) {
      toast.success("Akun berhasil dibuat");
      navigate("/");
    } else {
      setError(res.error);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background grain px-5 py-10">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 mb-8 justify-center">
          <div className="w-9 h-9 bg-primary flex items-center justify-center neon-glow">
            <Ticket weight="fill" size={22} className="text-black" />
          </div>
          <span className="font-heading font-black text-2xl tracking-tighter">EVENT<span className="text-primary">KU</span></span>
        </Link>
        <div className="bg-card border border-white/10 p-8">
          <h1 className="font-heading text-3xl font-black tracking-tight mb-1">Daftar</h1>
          <p className="text-zinc-500 text-sm mb-6">Buat akun untuk mulai membeli tiket.</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label className="text-xs uppercase tracking-widest text-zinc-400">Nama Lengkap</Label>
              <Input data-testid="register-name" required value={form.name} onChange={set("name")}
                className="mt-1.5 bg-zinc-900 border-zinc-800 focus:ring-primary focus:border-primary rounded-none" placeholder="Nama Anda" />
            </div>
            <div>
              <Label className="text-xs uppercase tracking-widest text-zinc-400">Email</Label>
              <Input data-testid="register-email" type="email" required value={form.email} onChange={set("email")}
                className="mt-1.5 bg-zinc-900 border-zinc-800 focus:ring-primary focus:border-primary rounded-none" placeholder="anda@email.com" />
            </div>
            <div>
              <Label className="text-xs uppercase tracking-widest text-zinc-400">No HP</Label>
              <Input data-testid="register-phone" value={form.phone} onChange={set("phone")}
                className="mt-1.5 bg-zinc-900 border-zinc-800 focus:ring-primary focus:border-primary rounded-none" placeholder="08xxxxxxxxxx" />
            </div>
            <div>
              <Label className="text-xs uppercase tracking-widest text-zinc-400">Password</Label>
              <Input data-testid="register-password" type="password" required value={form.password} onChange={set("password")}
                className="mt-1.5 bg-zinc-900 border-zinc-800 focus:ring-primary focus:border-primary rounded-none" placeholder="••••••••" />
            </div>
            {error && <p data-testid="register-error" className="text-sm text-secondary">{error}</p>}
            <Button data-testid="register-submit" type="submit" disabled={loading}
              className="w-full bg-primary text-black font-bold hover:bg-cyan-300 rounded-none h-11">
              {loading ? "Memproses..." : "Daftar"}
            </Button>
          </form>
          <p className="text-sm text-zinc-500 mt-6 text-center">
            Sudah punya akun?{" "}
            <Link to="/login" data-testid="go-login" className="text-primary font-semibold hover:underline">Masuk</Link>
          </p>
          <SocialOtpAuth />
        </div>
      </div>
    </div>
  );
}
